// extracted by mini-css-extract-plugin
export var active = "SwipeableScrolling-module--active--ac8a3";
export var cardContent = "SwipeableScrolling-module--cardContent--3bd50";
export var container = "SwipeableScrolling-module--container--4e939";
export var detail = "SwipeableScrolling-module--detail--578cd";
export var detailContent = "SwipeableScrolling-module--detailContent--b9220";
export var downImage = "SwipeableScrolling-module--downImage--d24c2";
export var imageContent = "SwipeableScrolling-module--imageContent--22901";
export var item = "SwipeableScrolling-module--item--d1e4a";
export var mainImage = "SwipeableScrolling-module--mainImage--ae18e";
export var navigationContent = "SwipeableScrolling-module--navigationContent--03600";
export var otherImage = "SwipeableScrolling-module--otherImage--2bac8";
export var upImage = "SwipeableScrolling-module--upImage--fc917";